// extracted by mini-css-extract-plugin
export default {"wrapper":"R2-z","play":"S2-z"};